export const QUESTION_ORDER = [
  'isVet',
  'benefits',
  'authorized',
  'reasonFor',
  'schedule',
  'visit',
  'driveTime',
  'tried',
  'waitTime',
  'qualify'
]

export const QUESTION_ANALYTICS_NAMES = {
  isVet: 'isVeteran',
  benefits: 'hasVAHealthcare',
  authorized: 'hasAuthorization',
  reasonFor: 'reason',
  schedule: 'scheduleJeffVet',
  visit: 'insuranceToUse',
  driveTime: 'driveTime',
  tried: 'triedAppt',
  waitTime: 'waitTime',
  qualify: 'qualifyFor'
}
